import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "material-icons/iconfont/material-icons.css";
import { UserProvider } from "./contexts/UserContext";
import { I18nProvider } from "./locales/i18n";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <UserProvider>
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <I18nProvider>
          <App />
          <ToastContainer />
        </I18nProvider>
      </BrowserRouter>
    </UserProvider>
  </React.StrictMode>
);

reportWebVitals();
